/**
 * Lucide icons initialisation.
 *
 * Any element with a data-lucide attribute is replaced with the matching
 * inline SVG after the DOM is ready:
 *
 *   <i data-lucide="terminal"></i>
 *   <i data-lucide="arrow-right" class="uk-icon"></i>
 *
 * Icons are tree-shaken at build time — only the names actually imported
 * here are included in the bundle. Add new icons to the import list below.
 *
 * Full icon reference: https://lucide.dev/icons
 */

import { createIcons, icons } from 'lucide';

export default function initLucide() {
    createIcons({ icons });

    // Gravity Forms AJAX confirmations are injected after page load, so any
    // data-lucide elements in the confirmation message need a second pass.
    if (window.jQuery) {
        window.jQuery(document).on('gform_confirmation_loaded', () => {
            createIcons({ icons });
        });
    }
}
